module.exports = __webpack_public_path__ + "img/foto-jose-renato-mannis.jpg";